<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title || margin">{{ content.title }}</h1>
        <p v-if="content.description" class="card-header-statistic">
          {{ content.description }}
        </p>
        <p v-if="optionData.label" class="card-footer-label || large-margin">
          {{ optionData.label }}
        </p>
      </div>
      <p
        v-if="optionData.description"
        class="card-footer-label || small-margin"
      >
        {{ optionData.description }}
      </p>
      <CustomIcon
        v-if="optionData.icon"
        :name="optionData.icon"
        class="card-image || small"
      />
      <p v-if="optionData.text" class="card-footer-subtext">
        {{ optionData.text }}
      </p>
      <CustomButton variation="primary" :onClick="action"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomButton from "@/components/CustomButton.vue";
export default {
  components: {
    CustomIcon,
    CustomButton,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        title: String,
        description: String,
        image: String,
        options: Array,
      }),
    },
  },
  computed: {
    optionData() {
      if (this.content.options.length > 0) {
        return this.content.options[0];
      }

      return null;
    },
  },
};
</script>
